module.exports = __webpack_public_path__ + "static/media/Step 4-Follower_Cards.1f974d09.png";